import React from 'react';
import classnames from 'classnames';

import styles from './styles.styl';

export default (props) => {
  return (
    <button
      onClick={!props.disabled ? props.onClick : undefined}
      type={props.type || 'button'}
      disabled={props.disabled}
      title={props.title}
      style={props.style}
      className={classnames(props.className, styles.container, {
        [styles.primary]: props.primary,
        [styles.success]: props.success,
        [styles.primary_light]: props.primaryLight,
        [styles.empty]: props.empty,
        [styles.light]: props.light,
        [styles.disabled]: props.disabled,
        [styles.block]: props.block,
        [styles.button_dropdown]: props.dropdown,
      })}
    >
      {props.children}

      {(props.dropdown || props.link_dropdown) &&
        <i className={styles.arrow} />
      }
    </button>
  );
};




// WEBPACK FOOTER //
// ./src/components/shared/Button/index.js